export default __webpack_public_path__ + "static/media/trophy-solid.904ce25a.svg";